import { Link } from "react-router-dom";
import { news } from "@/mocks/news";
import { movies } from "@/mocks/movies";
import SectionHeading from "@/components/base/SectionHeading";

const latestNews = news.slice(0, 5);
const ranking = [...movies].sort((a, b) => b.rating - a.rating).slice(0, 5);

export default function HomeSidebar() {
  return (
    <aside className="flex flex-col gap-6">
      {/* 最新资讯 */}
      <div className="rounded-lg bg-background-50 border border-background-200 p-4">
        <SectionHeading title="影视资讯" moreTo="/news" icon="ri-article-line" />
        <ul className="flex flex-col divide-y divide-background-200">
          {latestNews.map((item, index) => (
            <li key={item.id}>
              <Link
                to={`/news/detail/${item.id}`}
                className="group flex gap-3 py-3 cursor-pointer"
              >
                <span
                  className={`shrink-0 w-5 h-5 mt-0.5 rounded text-xs font-label font-bold flex items-center justify-center ${
                    index < 3 ? "bg-accent-500 text-white" : "bg-background-200 text-foreground-500"
                  }`}
                >
                  {index + 1}
                </span>
                <div className="min-w-0">
                  <p className="text-sm text-foreground-800 leading-snug line-clamp-2 group-hover:text-primary-700 transition-colors">
                    {item.title}
                  </p>
                  <p className="mt-1 text-xs text-foreground-400">{item.date}</p>
                </div>
              </Link>
            </li>
          ))}
        </ul>
      </div>

      {/* 热播榜 */}
      <div className="rounded-lg bg-background-50 border border-background-200 p-4">
        <SectionHeading title="高分热播榜" moreTo="/category?sort=rating" icon="ri-trophy-line" />
        <ul className="flex flex-col gap-3">
          {ranking.map((movie, index) => (
            <li key={movie.id}>
              <Link
                to={`/detail/${movie.id}`}
                className="group flex items-center gap-3 cursor-pointer"
              >
                <div className="relative w-12 h-16 shrink-0 rounded-md overflow-hidden bg-background-200">
                  <img
                    src={movie.poster}
                    alt={`${movie.title} 封面`}
                    title={`${movie.title} - 影视影院高分热播榜`}
                    className="w-full h-full object-cover object-top"
                  />
                  <span className="absolute top-0 left-0 w-5 h-5 bg-accent-500 text-white text-xs font-label font-bold flex items-center justify-center rounded-br-md">
                    {index + 1}
                  </span>
                </div>
                <div className="min-w-0 flex-1">
                  <p className="text-sm font-label font-bold text-foreground-900 truncate group-hover:text-primary-700 transition-colors">
                    {movie.title}
                  </p>
                  <p className="mt-0.5 text-xs text-foreground-500 truncate">
                    {movie.type === "movie" ? "电影" : "电视剧"} · {movie.region}
                  </p>
                  <p className="mt-1 text-xs text-accent-600 font-label font-bold">
                    {movie.rating.toFixed(1)} 分
                  </p>
                </div>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </aside>
  );
}